import { request, COMPANY_ID, API_BASE_URL } from './apiClient';

export const createFile = async (file: File, fileURL: string, folderId: string) => {
  const url = `/company/${COMPANY_ID}/folder/files/file`;
  console.log(`[createFile] Calling: ${url} with folderId=${folderId}`);

  const formData = new FormData();
  formData.append('file', file);
  formData.append('fileName', file.name);
  formData.append('fileURL', fileURL);
  formData.append('folderId', folderId);

  return await request(url, {
    method: 'POST',
    body: formData,
  }, '');
};

export const downloadFile = async (fileName: string, folderId: string, userEmail: string) => {
  const url = `/company/${COMPANY_ID}/folder/files/download?fileName=${encodeURIComponent(fileName)}&folderId=${encodeURIComponent(folderId)}&userEmail=${encodeURIComponent(userEmail)}`;

  return await request<string>(url, {}, 'text/plain');
};

export const deleteFile = async (fileId: string, companyId: string, folderId: string) => {
  const url = `/company/${companyId}/folder/files/${fileId}?companyId=${encodeURIComponent(companyId)}&folderId=${encodeURIComponent(folderId)}`;

  await request(url, { method: 'DELETE' });
  return true;
};

export const updateFileAccess = async (fileId: string, view: boolean, download: boolean) => {
  const url = `/company/${COMPANY_ID}/folder/files/access`;
  console.log(`[updateFileAccess] Calling: ${url} with fileId=${fileId}`);

  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ fileId, view, download }),
  }, 'application/json');
};

export const updateFileName = async (fileId: string, fileName: string, folderId: string, companyId: string) => {
  const url = `/company/${COMPANY_ID}/folder/files/${fileId}`;
  console.log(`[updateFileName] Calling: ${url} with fileId=${fileId}`);

  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ fileName, folderId, companyId }),
  }, 'application/json');
};

export const moveFile = async (fileId: string, targetFolderId: string) => {
  const url = `/company/${COMPANY_ID}/folder/files/${fileId}/move`;
  console.log(`[moveFile] Calling: ${url} with targetFolderId=${targetFolderId}`);

  return await request(url, {
    method: 'PUT',
    body: JSON.stringify({ folderId: targetFolderId }),
  }, 'application/json');
};

export const getFileAccess = async (fileId: string): Promise<{ view: boolean; download: boolean }> => {
  const url = `/company/${COMPANY_ID}/folder/files/access/${fileId}`;

  return await request(url);
};

export const fetchPdfBlob = async (companyId: string, folderId: string, fileName: string): Promise<Blob> => {
  const endpoint = `/company/${companyId}/folder/files/view?companyId=${encodeURIComponent(companyId)}&folderId=${encodeURIComponent(folderId)}&fileName=${encodeURIComponent(fileName)}`;

  const token = sessionStorage.getItem('authToken');
  if (!token) throw new Error('No auth token found');

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch PDF: ${response.statusText}`);
  }

  return await response.blob();
};
